import axios from "axios";
import * as actionTypes from "../actionTypes";
import { getAuthToken } from "../../authConfig";

export const AppSectionStart = () => {
  return {
    type: actionTypes.APP_SECTION_START
  }
}
export const AppSectionSuccess = (data) => {
  return {
    type: actionTypes.APP_SECTION_COUNT,
    data: data
  };
};
export const AppDeploySuccess = (data) => {
  return {
    type: actionTypes.APP_DEPLOY_SECTION_COUNT,
    data: data
  };
};

export const AppSectionFail = (error) => {
  return {
    type: actionTypes.APP_SECTION_ERROR,
    error: error
  };
};
export const AppSectionId = (id) => {
  return {
    type: actionTypes.APP_SECTION_ID,
    id: id
  };
};

export const AppSectionDetails = () => dispatch => new Promise((resolve, reject) => {
        dispatch(AppSectionStart())
        getAuthToken()
        axios.get(`/api/categories/`)
          .then(response => {
              dispatch(AppSectionSuccess(response.data.data));
              resolve(response.data.data);
            })
          .catch(err => {
            dispatch(AppSectionFail(err.response.data));
            reject(err.response.data)
          });
  })


export const AppSelection = (id) => {
  return dispatch => {
    getAuthToken()
    let url1 = `/api/categories/${id}`;
    dispatch(AppSectionStart())
    axios.get(url1)
      .then(response => {
        dispatch(AppDeploySuccess(response.data.data));
      })
      .catch(err => {
        dispatch(AppSectionFail(err.response.data));
      });
  }

};

export const AppInstall = (id,appId) => {
  return dispatch => {
    getAuthToken()
    let data= {
      "app_registry" :id
    }
    let url1 = `/api/apps/?is_global=true`;
    dispatch(AppSectionStart())
    axios.post(url1,data)
      .then(() => {
        dispatch(AppSelection(appId))
      })
      .catch(err => {
        dispatch(AppSectionFail(err.response.data));
      });
  }

};